export const ConfirmTypes = {
    QUESTION: 'question',
    ALERT: 'alert',
    INFORM: 'inform'
}